
import { Vue, Component, Watch } from 'vue-property-decorator'
import dayjs from 'dayjs'
import { TotalDataDTO, getOrderMonitoringTotal, getOrderMonitoringByDay, getOrderMonitoringByWeek, getOrderMonitoringByMonth } from '@/api/dataReport'
import { moneyFormat } from '@/utils/util'
import { exportFileWithData } from '@/utils/h5ToApp'
import { chartOption } from '@/views/dataReport/echartsConfig'
import OrderListCard from '@/views/dataReport/template/OrderListCard.vue'
import { Getter } from 'vuex-class'
import moment from 'moment'
import DataSelect from '@/views/dataReport/template/dataSelect.vue'

let echarts = require('echarts')

@Component({
  components: {DataSelect, OrderListCard}
})
export default class OrderMonitor extends Vue {
  @Getter companyId!: string
  moneyFormat = moneyFormat
  chartOption = chartOption
  readonly format = 'YYYY-MM-DD'
  myChart: any = null
  queryParams = {
    startTime: moment().month(moment().month() - 2).format(this.format),
    endTime: dayjs().format(this.format),
    type: 1,
    isPage: true,
    pageIndex: 1,
    pageSize: 366
  }

  refreshing = false //下拉刷新

  lineType = [
    {
      text: '按订单数',
      value: 0,
      key: 'orderSum'
    },
    {
      text: '按退单数',
      value: 1,
      key: 'returnOrderSum'
    },
    {
      text: '按订货金额',
      value: 2,
      key: 'orderMoney'
    },
    {
      text: '按退款金额',
      value: 3,
      key: 'returnOrderMoney'
    },
    {
      text: '按合计金额',
      value: 4,
      key: 'differenceMoney'
    },
  ]

  lineTypeValue = 0
  dateType = 0
  list = []

  load () {
    this.getOrderMonitoringTotal()
    this.handleDateTypeChange()
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.refreshing = true
    this.load()
  }

  gridData = [
    {
      title: '订货单',
      key: 'orderSum'
    },
    {
      title: '订货客户数',
      key: 'orderCustomerId'
    },
    {
      title: '订货金额',
      key: 'orderMoney',
      type: 'money'
    },
    {
      title: '退货金额',
      key: 'returnMoneySum',
      type: 'money'
    },
    {
      title: '退货客户数',
      key: 'returnOrderCustomerId'
    },
    {
      title: '退货单',
      key: 'returnOrderSum'
    },
    {
      title: '获批退款金额',
      key: 'returnOrderMoney',
      type: 'money'
    },
    {
      title: '合计总金额',
      key: 'differenceMoney',
      type: 'money'
    },
  ]

  totalData: TotalDataDTO | any = {}

  dateTypeActive (type: number) {
    return type === this.dateType ? 'date-type-btn date-type-btn-active' : 'date-type-btn'
  }

  created () {
    this.getOrderMonitoringTotal()
  }

  mounted () {
    this.drawLine()
  }

  getOrderMonitoringTotal () {
    getOrderMonitoringTotal({
      ...this.queryParams
    }).then(res => {
      this.totalData = res.data[0]
    })
  }

  /**
   * 监听时间类型的变化
   */
  @Watch('dateType', {immediate: true})
  handleDateTypeChange () {
    const requests = [getOrderMonitoringByDay, getOrderMonitoringByWeek, getOrderMonitoringByMonth]
    switch (this.dateType) {
      case 0:
        this.queryParams.type = 1
        break
      case 1:
        this.queryParams.type = 3
        break
      case 2:
        this.queryParams.type = 2
        break
    }
    requests[this.dateType]({
      ...this.queryParams
    }).then(res => {
      this.list = res.data.records
      this.changeChartData()
    }).finally(() => {
      this.refreshing = false
    })
  }

  drawLine () {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.getElementById('order-monitor-chart-container') as HTMLElement)
    // 绘制图表
    this.myChart.setOption(this.chartOption)
    setTimeout(() => {
      this.resizeEchart()
    })
  }

  /**
   * 设置Echarts自适应
   */
  resizeEchart () {
    echarts.init(document.getElementById('order-monitor-chart-container') as HTMLElement).resize()
  }

  changeChartData () {
    this.chartOption.xAxis.data = this.list.map(item => item.date) as any
    this.chartOption.series[0].data = this.list.map((item: any) => {
      const types = ['orderSum', 'returnOrderSum', 'orderMoney', 'returnOrderMoney', 'differenceMoney']
      return item[types[this.lineTypeValue]]
    }) as any
    this.$nextTick(() => {
      this.drawLine()
    })
  }

  handleDataChange (value: Array<string>) {
    this.queryParams.startTime = value[0]
    this.queryParams.endTime = value[1]
    this.load()
  }

  handleLineTypeChange () {
    this.changeChartData()
  }

  // 导出
  handleExport () {
    exportFileWithData({
      method: 'post',
      portUrl: '/cykjreport/OrderMonitoring/exportPullOrderMonitoring',
      params: JSON.stringify(Object.assign({companyId: this.companyId}, {...this.queryParams}))
    })
  }
}
